export default __webpack_public_path__ + "static/media/38da7de36057af07.ac69353629ec90dd46269c61c8cb24ef.svg";